import { render, staticRenderFns } from "./fklb.vue?vue&type=template&id=224c00b4&scoped=true&"
import script from "./fklb.vue?vue&type=script&lang=js&"
export * from "./fklb.vue?vue&type=script&lang=js&"
import style0 from "./fklb.vue?vue&type=style&index=0&id=224c00b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c00b4",
  null
  
)

export default component.exports